module.exports = __webpack_public_path__ + "static/media/MannaWeigherAppIcon.fe8ecc29.svg";